<div nz-row class="project-card">
  <div nz-col nzMd="24" nzSm="24">
    <div nz-row>
      <div nz-col nzSpan="6" class="column budget" [nz-tooltip]="!loading ? formatNumber(ProjectMetrics.Budget.baselineBudget) : ''">
          <div nz-flex nzVertical="true">
            <div nz-flex nzAlign="center">
              <span
                nz-icon
                nzType="diazar:donateIcon"
                nzTheme="outline"
                class="icon"
              ></span>
              <span class="title">Presupuesto</span>
            </div>
            <nz-skeleton
              [nzLoading]="loading"
              [nzActive]="true"
              [nzParagraph]="{ rows: 0 }"
            >
              <span class="value">
                  {{ !loading ? (ProjectMetrics.Budget.baselineBudget | shortCurrency).amount : ''}}
                  <span class="currencySuffix">{{ !loading ? (ProjectMetrics.Budget.baselineBudget | shortCurrency).suffix : '' }}</span>

              </span>
            </nz-skeleton>
          </div>
      </div>
      <div nz-col nzSpan="6" class="column" [nz-tooltip]="!loading ? formatNumber(ProjectMetrics.Budget.controlBudget) : ''">
        <div nz-flex nzVertical="true">
          <div nz-flex nzAlign="center">
            <span
              nz-icon
              nzType="diazar:donateIcon"
              nzTheme="outline"
              class="icon"
            ></span>
            <span class="title">Proyecto de Control</span>
          </div>
          <nz-skeleton
            [nzLoading]="loading"
            [nzActive]="true"
            [nzParagraph]="{ rows: 0 }"
          >
            <span class="value">
              {{ !loading ? (ProjectMetrics.Budget.controlBudget | shortCurrency).amount : '' }}
              <span class="currencySuffix">{{ !loading ?  (ProjectMetrics.Budget.controlBudget | shortCurrency).suffix : '' }}</span>
            </span>
<!--            <span class="dates">-->
<!--              Inicio:-->
<!--              {{-->
<!--                ProjectMetrics.Budget.start_date | date : "dd-MM-yyyy"-->
<!--              }}-->
<!--            </span>-->
          </nz-skeleton>
        </div>
      </div>
      <div nz-col nzSpan="6" class="column center" [nz-tooltip]="!loading ? formatNumber(ProjectMetrics.ExecutionCost.ProjectExecutionCost) : ''">
        <div nz-flex nzVertical="true">
          <div nz-flex nzAlign="center">
            <span
              nz-icon
              nzType="fund-view"
              nzTheme="outline"
              class="icon"
            ></span>
            <span class="title">Ejecutado</span>
          </div>
          <nz-skeleton
            [nzLoading]="loading"
            [nzActive]="true"
            [nzParagraph]="{ rows: 1 }"
          >
            <div nz-flex nzAlign="center">
              <span class="value">
                {{ !loading ? (ProjectMetrics.ExecutionCost.ProjectExecutionCost | shortCurrency).amount : ''}}
                <span class="currencySuffix">{{!loading ? (ProjectMetrics.ExecutionCost.ProjectExecutionCost | shortCurrency).suffix : '' }}</span>
              </span>
            </div>
            <div>
              <nz-progress [nzPercent]=" !loading ? toDecimal(ProjectMetrics.ExecutionCost.progress, 2) : 0" ></nz-progress>
            </div>
          </nz-skeleton>
        </div>
      </div>
      <div nz-col nzSpan="6" class="column" [nz-tooltip]="!loading ? formatNumber(ProjectMetrics.ExecutionCost.remainingBudget) : ''">
          <div nz-flex nzVertical="true">
            <div nz-flex nzAlign="center">
              <span
                nz-icon
                nzType="fund"
                nzTheme="outline"
                class="icon"
              ></span>
              <span class="title">Por Ejecutar</span>
            </div>
            <nz-skeleton
              [nzLoading]="loading"
              [nzActive]="true"
              [nzParagraph]="{ rows: 1 }"
            >
              <div nz-flex nzAlign="center">
                <span class="value">
                  {{ !loading ? (ProjectMetrics.ExecutionCost.remainingBudget | shortCurrency).amount : '' }}
                  <span class="currencySuffix">
                    {{ !loading ? (ProjectMetrics.ExecutionCost.remainingBudget | shortCurrency).suffix : ''}}
                  </span>
                </span>
              </div>
              <div>
                <nz-progress [nzPercent]="!loading ? toDecimal(100 - ProjectMetrics.ExecutionCost.progress, 2) : 0" [nzSuccessPercent]="0"></nz-progress>
              </div>
            </nz-skeleton>
          </div>
      </div>
    </div>
  </div>
</div>
